import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';

import FacesCheck from './FacesCheck';
import FACES from '../../constants/faces';

function FacesCheckContainer({ content, setCompleted }) {
  const faces = useMemo(
    () =>
      content
        .map((i, j) => new Array(i).fill(j))
        .flat()
        .map((i, j) => ({
          index: j,
          face: FACES[i],
        })),
    [content],
  );
  const [checked, setChecked] = useState(() => Array(faces.length).fill(false));
  const onCheck = useCallback(
    (i) => {
      setChecked((cc) => {
        const c = [...cc];
        c[i] = !c[i];
        setCompleted(c.every((v) => v));
        return c;
      });
    },
    [setCompleted],
  );
  return <FacesCheck checked={checked} faces={faces} onCheck={onCheck} />;
}

FacesCheckContainer.propTypes = {
  content: PropTypes.array.isRequired,
  setCompleted: PropTypes.func.isRequired,
};

export default FacesCheckContainer;
